import { useMutation } from '@tanstack/react-query';

import { printLabel } from '#/api/imsMgmt/inventoryStock/printLabel';
import { getInventoryStockApiErrorMessage } from '#/modules/imsMgmt/inventoryStock/helper/apiError';
import { toast } from '#/utils/toast';

/**
 * 庫存標籤列印 mutation：成功顯示 printedCount；失敗優先後端 message。
 * 入庫明細與庫存列表共用。
 * 引數可為 id 陣列（只印基本單位），或 `{ invStockIds, unitSelections }`。
 *
 * @param {{ onSuccess?: (result: object) => void }} [options]
 */
function usePrintInventoryStockLabels({ onSuccess } = {}) {
  return useMutation({
    mutationFn: (input) => {
      if (Array.isArray(input)) {
        return printLabel({ invStockIds: input });
      }
      return printLabel({
        invStockIds: input?.invStockIds ?? [],
        unitSelections: input?.unitSelections,
      });
    },
    onSuccess: (result) => {
      const printedCount = result?.data?.printedCount;
      if (printedCount != null && printedCount !== '') {
        toast.success(`已列印 ${printedCount} 筆庫存標籤`);
      } else {
        toast.success(result?.message || '列印成功');
      }
      onSuccess?.(result);
    },
    onError: (error) => {
      toast.error(getInventoryStockApiErrorMessage(error, '列印失敗，請稍後再試'));
    },
  });
}

export default usePrintInventoryStockLabels;
